import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

function formatTime(ms) {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

export default function InactivityWarningModal({ open, timeRemaining, onStaySignedIn, onSignOut }) {
  const { t } = useTranslation('common')

  useEffect(() => {
    if (!open) return
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onStaySignedIn()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, onStaySignedIn])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/40" />
      <div className="relative bg-white rounded-xl p-6 shadow-xl max-w-md w-full animate-fadeIn text-center">
        <div className="text-4xl mb-3">&#9200;</div>
        <h3 className="font-display text-xl font-medium text-gray-800 mb-2">
          {t('inactivityWarning.title')}
        </h3>
        <p className="text-gray-600 mb-1">
          {t('inactivityWarning.message')}
        </p>
        <p className="text-3xl font-mono font-bold text-primary-700 mb-6">
          {formatTime(timeRemaining)}
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={onSignOut}
            className="px-5 py-2.5 text-sm font-semibold text-gray-700 bg-gray-100 rounded-lg transition-all hover:bg-gray-200"
          >
            {t('inactivityWarning.signOut')}
          </button>
          <button
            onClick={onStaySignedIn}
            className="px-5 py-2.5 text-sm font-semibold text-white rounded-lg transition-all hover:shadow-lg bg-gradient-to-r from-primary-500 to-primary-600"
          >
            {t('inactivityWarning.staySignedIn')}
          </button>
        </div>
      </div>
    </div>
  )
}
